import { Box, Typography } from "@mui/material";

export default function PublishSummary() {
  return (
    <Box>
      <Typography variant="body1">
        Solicite a publicação do seu aplicativo iOS para dar início ao processo de publicação na App Store.
      </Typography>
    </Box>
  )
}